module.exports = __webpack_public_path__ + "static/Ilustracja2-e5f8d22e68df2e1ae17ecbf9b39dab66.svg";